module.exports = __webpack_public_path__ + "media/assets_v3/images/default-category-8bd25f9c9a08db8351eedf1e08892ce5.jpeg";